import { styled } from '@mui/joy';
import { FilePdf } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PreviewPdf } from 'core/components';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { IQuotePart } from 'quotes/types';

const DatasheetIcon = styled(FilePdf)({
  cursor: 'pointer',
  height: 24,
  width: 24,
});

export const DatasheetCell = (props: ICellRendererParams) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const data = getAgGridTableCellData(props, QuotePartColId.DATASHEET);

  if (!data) {
    return props?.value;
  }

  const { datasheetLink, datasheetFileName, number } = (data as IQuotePart).partArr || {};

  if (!datasheetLink) {
    return;
  }

  return (
    <>
      <DatasheetIcon onClick={() => setIsOpen(true)} />

      <PreviewPdf
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        fileName={datasheetFileName || t('labelDatasheetDefaultFileName', { number })}
        fileUrl={datasheetLink}
      />
    </>
  );
};
